const IMG = "/img/v2";

export const ASSETS = {
  logo: `${IMG}/lp-logo.webp`,
  shopee: `${IMG}/shopee.webp`,
  lazada: `${IMG}/lazada.webp`,
  google: `${IMG}/google.webp`,
  placeholderCover: `${IMG}/placeholder-cover.svg`,
  lifepac: `${IMG}/lifepac-1.webp`,
  lifepacSets: [
    `${IMG}/lifepac-1.webp`,
    `${IMG}/lifepac-2.webp`,
    `${IMG}/lifepac-3.webp`,
    `${IMG}/lifepac-4.webp`,
  ],
  // Real covers used as decorative sale-hero art (FannedCovers) only — NOT a
  // fallback for imageless products; that's `placeholderCover` via pickBookCover.
  books: [
    `${IMG}/book-1.webp`,
    `${IMG}/book-2.webp`,
    `${IMG}/book-3.webp`,
    `${IMG}/book-4.webp`,
    `${IMG}/book-5.webp`,
  ],
  bjuLogo: `${IMG}/bju-press-logo.webp`,
  bjuSets: [
    `${IMG}/bju-set-1.webp`,
    `${IMG}/bju-set-2.webp`,
    `${IMG}/bju-set-3.webp`,
    `${IMG}/bju-set-4.webp`,
  ],
  bjuCovers: [
    `${IMG}/bju-cover-1.webp`,
    `${IMG}/bju-cover-2.webp`,
    `${IMG}/bju-cover-3.webp`,
    `${IMG}/bju-cover-4.webp`,
    `${IMG}/bju-cover-5.webp`,
    `${IMG}/bju-cover-6.webp`,
  ],
  onSaleFan: `${IMG}/on-sale-fan.webp`,
  heroFaq: `${IMG}/hero-faq.webp`,
  heroTrack: `${IMG}/hero-track.webp`,
  heroReturns: `${IMG}/hero-returns.webp`,
  heroIntlShipping: `${IMG}/hero-intl-shipping.webp`,
  heroPrivacy: `${IMG}/hero-privacy.webp`,
  livingBooks: [`${IMG}/lb-1.webp`, `${IMG}/lb-2.webp`, `${IMG}/lb-3.webp`],
  livingBooksCovers: [
    `${IMG}/lb-sample-1.webp`,
    `${IMG}/lb-sample-2.webp`,
    `${IMG}/lb-sample-3.webp`,
    `${IMG}/lb-sample-4.webp`,
    `${IMG}/lb-sample-5.webp`,
    `${IMG}/lb-sample-6.webp`,
  ],
  categories: {
    childrens: `${IMG}/featured-1.webp`,
    novels: `${IMG}/cat-novels.webp`,
    textbooks: `${IMG}/cat-textbooks.webp`,
    filipino: `${IMG}/cat-filipino.webp`,
    resource: `${IMG}/cat-resource-book.webp`,
    living: `${IMG}/cat-living.webp`,
    ebooks: `${IMG}/cat-ebooks.webp`,
    merch: `${IMG}/cat-merch.webp`,
    online: `${IMG}/cat-online.webp`,
    supplies: `${IMG}/cat-supplies.webp`,
    bundles: `${IMG}/cat-bundles.webp`,
    bju: `${IMG}/cat-bju.webp`,
  },
} as const;

const FALLBACK_COVER = ASSETS.placeholderCover;

export function pickBookCover(_seed: string): string {
  return ASSETS.placeholderCover;
}

export function pickFromCovers(
  seed: string,
  covers: readonly string[],
): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return covers[h % covers.length] ?? FALLBACK_COVER;
}
